import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./PendingExtensionRequests.module.css";
import { COUNTRY_CODE_MAP } from "../../../constants/constant";

const PendingExtensionRequests = ({ data = [] }) => {
  const history = useHistory();

  const handleRowClick = () => {
    history.push("/extension/jdf");
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Pending Extension Requests</h3>
        <p className={styles.subtitle}>
          <span className={styles.icon}>⏱</span> 
          Overdue and due next working day
        </p>
      </div>

      <div className={styles.tableContainer}>
        {data.length === 0 ? (
          <div className={styles.emptyState}>No pending requests</div>
        ) : (
          <table className={styles.table}>
            <tbody>
              {data.map((item) => (
                <tr 
                  key={item.id} 
                  className={styles.tableRow}
                  onClick={handleRowClick}
                >
                  <td className={styles.countryCell}>
                    {COUNTRY_CODE_MAP[item.country] || item.country}
                  </td>
                  <td className={styles.amountCell}>
                    {item.ccm}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default PendingExtensionRequests;
